import React, { memo } from 'react';
import {
  ListItem,
  QuestionTitle,
  QuestionTitleText,
  QuestionContent,
  QuestionContainer,
  ExpandIcon,
} from './components';
import { Text } from '@spotify-internal/encore-web/core';
import { purify } from '../../lib/purify';

type QuestionPropTypes = {
  header: string;
  content: string;
};

function Question(props: QuestionPropTypes) {
  const { header, content } = props;

  return (
    <ListItem>
      <QuestionContainer>
        <QuestionTitle>
          <QuestionTitleText>
            <Text variant="titleSmall">{header}</Text>
          </QuestionTitleText>
          <ExpandIcon aria-hidden="true" />
        </QuestionTitle>
        <QuestionContent
          dangerouslySetInnerHTML={{ __html: purify(content) }}
        />
      </QuestionContainer>
    </ListItem>
  );
}

export default memo(Question);
